import React from 'react';
import { FINAL_BET_DATA_MODEL } from '../../../enums/tableNumbers';

export const FinalEnPlainNums = ({handleDoChip}) => {
  return (
    <div className="mob-finale-plein-circle-holder">
      {
        FINAL_BET_DATA_MODEL.map((item, index) => (
          <div className="mob-finale-plein-circle-item" key={item.type} ><span onClick={handleDoChip} data={item.type} >{index}</span></div>
        ))
      }
    </div>
  );
};